import { FilesState } from 'store/files/types';
import { RootState } from '../reducer';
import { createSelector } from 'reselect';

export const filesStateSelector = (state: RootState): FilesState => state.files;

export const selectFiles = createSelector(filesStateSelector, filesState => filesState.files);

export const selectUploadFilesStatus = createSelector(filesStateSelector, filesState => filesState.uploadFiles.status);
